import React, { useState } from "react";
import { Col, Form, Row, InputGroup, Button } from "react-bootstrap";
import {
  useCreateUserWithEmailAndPassword,
  useUpdateProfile,
} from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";
import { auth } from "../../../../firebase.init";
import HeroSection from "../../../Common/HeroSection/HeroSection";
import SocialLogin from "../Login/SocialLogin";

const SingUp = () => {
  const [validated, setValidated] = useState(false);
  const [pass, setPass] = useState("");
  const [createUserWithEmailAndPassword, user, loading, error] =
    useCreateUserWithEmailAndPassword(auth, { sendEmailVerification: true });
  const navigate = useNavigate();
  const [updateProfile] = useUpdateProfile(auth);

  const handleSubmit = async (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    event.preventDefault();
    setValidated(true);

    const displayName = event.target.name.value;
    const email = event.target.email.value;
    const password = event.target.password.value;

    createUserWithEmailAndPassword(email, password);
    await updateProfile({ displayName });
    alert("Updated profile");
  };

  if (user) {
    console.log(user);
    navigate("/");
  }

  return (
    <>
      <HeroSection name={"Register Now"}></HeroSection>
      <div className="container m-auto mb-5">
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <Row className="mb-3 d-flex flex-column">
            <Form.Group as={Col} md="4" controlId="validationCustom01">
              <Form.Label>Full Name</Form.Label>
              <Form.Control
                name="name"
                required
                type="text"
                placeholder="First name"
              />
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
            </Form.Group>

            <Form.Group as={Col} md="4" controlId="validationCustomEmail">
              <Form.Label>Email</Form.Label>
              <InputGroup hasValidation>
                <Form.Control
                  name="email"
                  type="email"
                  placeholder="E-mail"
                  aria-describedby="inputGroupPrepend"
                  required
                />
                <Form.Control.Feedback type="invalid">
                  Please input a valid E-mail.
                </Form.Control.Feedback>
              </InputGroup>
            </Form.Group>
            <Form.Group as={Col} md="4" controlId="validationCustomPassword">
              <Form.Label>Password</Form.Label>
              <InputGroup hasValidation>
                <Form.Control
                  name="password"
                  type="Password"
                  placeholder="*******"
                  aria-describedby="inputGroupPrepend"
                  required
                />
                <Form.Control.Feedback type="invalid">
                  Please input password.
                </Form.Control.Feedback>
              </InputGroup>
            </Form.Group>
            <Form.Group
              as={Col}
              md="4"
              controlId="validationCustomCheckPassword"
            >
              <Form.Label>Re type Password</Form.Label>
              <InputGroup hasValidation>
                <Form.Control
                  name="rePassword"
                  type="Password"
                  placeholder="*******"
                  aria-describedby="inputGroupPrepend"
                  required
                />
                <Form.Control.Feedback
                  type={pass !== setPass ? "valid" : "invalid"}
                >
                  Password Dose Not Match
                </Form.Control.Feedback>
              </InputGroup>
            </Form.Group>
          </Row>
          <p>{error && error.message}</p>
          <Form.Group className="mb-3">
            <Form.Check
              required
              label="Agree to terms and conditions"
              feedback="You must agree before submitting."
              feedbackType="invalid"
            />
          </Form.Group>

          <Button type="submit">Submit form</Button>
        </Form>

        <div className="w-50">
          <hr />
          <SocialLogin></SocialLogin>
        </div>
      </div>
    </>
  );
};
export default SingUp;
